import PageDocumentTitle from './PageDocumentTitle';

export default PageDocumentTitle;
